import request from '@/utils/request'

let AdvApi = {
  /*广告列表*/
   advList(data) {
    return request._post('/shop/plus.adv.adv/index', data);
  },
  /*添加广告*/
  addAdv(data) {
    return request._post('/shop/plus.adv.adv/add', data);
  },
  /*获取广告数据*/
  getAdv(data) {
    return request._get('/shop/plus.adv.adv/edit', data);
  },

  /*保存广告*/
  saveAdv(data) {
    console.log(data)
    return request._post('/shop/plus.adv.adv/edit', data);
  },
  /*删除广告*/
  delAdv(data) {
    return request._post('/shop/plus.adv.adv/delete', data);
  },
  /*查看商品*/
  seeAdv(data) {
    return request._post('/shop/plus.adv.adv/see', data);
  },

  /*等级列表*/
  orderLists(data) {
    return request._post('/shop/plus.adv.order/index', data);
},
/*添加等级*/
addOrder(data) {
    return request._post('/shop/plus.adv.order/add', data);
},
/*修改等级*/
editOrder(data) {
    return request._post('/shop/plus.adv.order/edit', data);
},
/*删除等级*/
deleteorder(data) {
    return request._post('/shop/plus.adv.order/delete', data);
},

  /*保存设置*/
  saveSetting(data) {
    return request._post('/shop/plus.adv.Setting/index', data);
  },
  /*获取设置*/
  getSetting(data) {
    return request._get('/shop/plus.adv.Setting/index', data);
  },
  /*获取设置*/
    getDiySkill(data) {
    return request._post('/shop/plus.adv.adv/getDiyProduct', data);
},
}
export default AdvApi;



// WEBPACK FOOTER //
// ./src/api/adv.js